import AuthorizationForm from "../../Items/Forms/AuthorizationForm";

export default function AuthorizationSection({ language, onAuthorizationSuccess }) {
  return (
    <section className="authorization-section flex-column">
      <AuthorizationForm language={language} onAuthorizationSuccess={onAuthorizationSuccess} />
    </section>
  );
}
